import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { PATIENT_ESTIMATE_ERROR_MESSAGES } from '@patient-ui/shared/constants';

import * as PatientEstimateActions from './patient-estimate.actions';
import { PatientEstimateService } from './patient-estimate.service';

@Injectable()
export class PatientEstimateEffects {
  constructor(
    private actions$: Actions,
    private patientEstimateService: PatientEstimateService
  ) {}

  VerifyPatientEstimate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PatientEstimateActions.VerifyPatientEstimate),
      exhaustMap((action) =>
        this.patientEstimateService.verifyPatientEstimate(action.payload).pipe(
          map((response) =>
            PatientEstimateActions.VerifyPatientEstimateSuccess({
              response,
            })
          ),
          catchError((errorRes: HttpErrorResponse) => {
            let errorMessage = '';
            const { status, error } = errorRes;

            // Handle specific HTTP status codes
            if (status === 0) {
              // Network error or CORS issue
              errorMessage = PATIENT_ESTIMATE_ERROR_MESSAGES.notFound;
            } else if (status === 404) {
              // Cost estimate expired or not found
              errorMessage = PATIENT_ESTIMATE_ERROR_MESSAGES.expired;
            } else if (status === 400 || status === 403) {
              errorMessage = PATIENT_ESTIMATE_ERROR_MESSAGES.notFound;
            } else {
              errorMessage =
                error?.message || PATIENT_ESTIMATE_ERROR_MESSAGES.notFound;
            }

            const errorPayload = {
              status: status || 500,
              message: errorMessage,
            };
            return of(
              PatientEstimateActions.VerifyPatientEstimateFailure({
                error: errorPayload,
              })
            );
          })
        )
      )
    )
  );
}
